/* ==========================================================================
   Asma ul Husna isim secici

   ⚠️ SINIF ADLARINI TEMAYA "UYDURMAYIN". Bu dosya kasitli olarak temanin
   varyant siniflarindan uzak durur:

     assets/variant-label-fix.js (574 satir) sayfa genelinde
       - document.querySelectorAll('input[type="radio"]:checked') uzerinde
         attribute yazar, ve
       - .dropdown-item dugumlerini klonlayip degistirir (listener'lari yok
         eder), bunu yuklemede + variant:change'de + 1 sn'lik interval ile
         5 kez tekrar yapar.

   Bu yuzden picker CHECKBOX kullanir ve su siniflara hic dokunmaz:
     variant-input, variant-input-wrap, variant__button-label,
     variant__label--selected, dropdown-item
   Bunlardan birine gecilirse ozellik sessizce bozulur.

   Ayni sebeple grid HICBIR ZAMAN yeniden render edilmez; arama yalnizca
   <li> uzerinde hidden toggle'lar. assets/size-unit-switch.js body uzerinde
   bir MutationObserver tutuyor, innerHTML ile yeniden yazmak onu bosuna
   tetikler ve secim state'ini kaybettirir.

   Fiyat mantigi BURADA YOK ve picker adet kontrolunu SURUKLEMEZ. Akis tek
   yonlu: musteri adedi 'Number of Names' kontrolunden secer, picker onu
   hedef olarak okur ve o kadar isim secilmesini bekler. Fiyat, SKU ve URL
   guncellemesini theme.Variants kendi akisinda yapar.
   ========================================================================== */

(function () {
  'use strict';

  var CHUNK_MAX = 450;

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  /* '7 Pieces' -> 7 · '1 Piece' -> 1 · 'Full Set - 103 pieces' -> 103 */
  function countOf(value) {
    var m = String(value || '').match(/\d+/);
    return m ? parseInt(m[0], 10) : null;
  }

  /* Metinler Liquid'den data-attribute ile gelir; [n] ve [t] yer tutuculari
     burada doldurulur. Sabit Ingilizce metin birakilmaz. */
  function T(root, key, fallback) {
    return root.getAttribute('data-np-t-' + key) || fallback;
  }

  function fill(tpl, n, t) {
    return String(tpl).replace('[n]', n).replace('[t]', t);
  }

  function Picker(root) {
    this.root = root;
    this.form = document.getElementById(root.getAttribute('data-np-form'));
    this.grid = root.querySelector('[data-np-grid]');
    this.counter = root.querySelector('[data-np-counter]');
    this.hint = root.querySelector('[data-np-hint]');
    this.empty = root.querySelector('[data-np-empty]');
    this.search = root.querySelector('[data-np-search]');
    this.clear = root.querySelector('[data-np-clear]');

    this.checks = toArray(root.querySelectorAll('[data-np-check]'));
    this.items = toArray(root.querySelectorAll('[data-np-item]'));
    this.publics = toArray(root.querySelectorAll('[data-np-public]')).sort(function (a, b) {
      return +a.getAttribute('data-np-public') - +b.getAttribute('data-np-public');
    });
    this.codesInput = root.querySelector('[data-np-codes]');
    this.countInput = root.querySelector('[data-np-count]');

    this.optionIndex = root.getAttribute('data-np-option-index');
    this.scope = document.getElementById(root.getAttribute('data-np-scope')) || document;
    this.optionLabel = root.getAttribute('data-np-option-label') || 'Number of Names';
    this.target = null;

    this.readCountOptions();
    this.bind();
    this.syncTargetFromVariant();
    this.render();
  }

  /* Adet secenekleri DOM'dan okunur, Liquid'den degil: admin'de kademe
     eklenip cikarildiginda bu dosya degismesin diye.

     Adet kontrolu bu urunde <select> (variant-dropdown.liquid), katalogun
     geri kalaninda radio (variant-button.liquid). Ikisi de desteklenir --
     picker'in hangi kontrole bagli oldugu merchandising karari. */
  Picker.prototype.readCountOptions = function () {
    /* Grup data-handle ile DEGIL data-index ('option3') ile bulunur.
       data-handle secenek adinin handleize'i ve ad aktif dilde geliyor: /de'de
       'anzahl-der-namen', /ar'da 'عدد-الأسماء'. Ilk surum handle'a bakiyordu,
       cevrilmis her dilde grup bulunamadi, hedef null kaldi ve siparise isim
       hic yazilmadi. Pozisyonu Liquid (name-picker-count-option) verir.
       Arama urunun kendi bolumuyle sinirli: ayni sayfada baska bir urunun
       'option3'u de olabilir. */
    var wrap = this.optionIndex
      ? this.scope.querySelector('.variant-input-wrap[data-index="' + this.optionIndex + '"]')
      : null;
    this.countWrap = wrap;
    /* Temanin kendi radio'lari -- gizli ama islevsel; gercek varyant secimi
       onlar uzerinden olur. */
    this.countInputs = wrap ? toArray(wrap.querySelectorAll('input[data-variant-input]')) : [];
    /* Musterinin gordugu kontrol. */
    this.ownSelect = this.root.querySelector('[data-np-count-select]');
    var counts = this.countInputs
      .map(function (i) { return countOf(i.value); })
      .filter(function (n) { return n !== null; });
    this.maxCount = counts.length ? Math.max.apply(null, counts) : null;
  };

  /* Kendi dropdown'imizdan temanin radio'suna. Deger karsilastirmasi
     attribute selector ile DEGIL input.value uzerinden: secenek degerleri
     tirnak icerebiliyor ve assets/dropdown-sold-out-handler.js ayni tuzagi
     belgeliyor. */
  Picker.prototype.applyCount = function (value) {
    for (var i = 0; i < this.countInputs.length; i++) {
      var input = this.countInputs[i];
      if (input.value !== value) continue;
      if (input.disabled || input.classList.contains('disabled')) return false;
      if (input.checked) return true;
      input.checked = true;
      input.setAttribute('checked', 'checked');
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  };

  Picker.prototype.selected = function () {
    return this.checks.filter(function (c) { return c.checked; });
  };

  Picker.prototype.syncTargetFromVariant = function () {
    var checked = this.countInputs.filter(function (i) { return i.checked; })[0];
    this.target = checked ? countOf(checked.value) : null;
    /* Varyant baska bir yoldan degistiyse (URL, geri tusu, baska bir kontrol)
       kendi dropdown'imizi ona hizala. */
    if (checked && this.ownSelect && this.ownSelect.value !== checked.value) {
      this.ownSelect.value = checked.value;
    }
  };

  Picker.prototype.bind = function () {
    var self = this;

    this.grid.addEventListener('change', function (evt) {
      var check = evt.target.closest ? evt.target.closest('[data-np-check]') : null;
      if (!check) return;

      /* ADET KONTROLU BELIRLEYICI, PICKER ONU SURUKLEMEZ.
         Ilk surumde surukluyordu: secim adedi hangi kademeye denk geliyorsa
         varyant ona cekiliyordu. Adet secenegi picker'in ustune 'NUMBER OF
         NAMES' etiketiyle tasinip dropdown'a donunce bu ters tepti --
         musteri 8 secip ilk isme tikladiginda n=1 oluyor, '1 Piece' varyanti
         var oldugu icin dropdown 1'e donuyor, sonra her tik 2, 3, 4 diye
         ilerliyordu. Artik hedefi yalnizca dropdown belirler. */
      if (check.checked && self.target !== null && self.selected().length > self.target) {
        check.checked = false;
        /* Ust kademedeyse gercekten sinir; degilse yapilacak sey belli, onu
           soyle: adedi yukselt. */
        var atCeiling = self.maxCount !== null && self.target >= self.maxCount;
        var msg = atCeiling
          ? T(self.root, 'at-max', '[n] names is the most you can order at once.')
          : T(self.root, 'at-target', "That's all [n]. To choose more, raise [o] above.");
        self.setHint(fill(msg, self.target).split('[o]').join(self.optionLabel));
        return;
      }

      self.render();
    });

    if (this.ownSelect) {
      this.ownSelect.addEventListener('change', function () {
        self.applyCount(self.ownSelect.value);
        self.syncTargetFromVariant();
        self.render();
      });
    }

    if (this.search) {
      this.search.addEventListener('input', function () {
        self.filter(self.search.value);
      });
    }

    if (this.clear) {
      this.clear.addEventListener('click', function () {
        self.checks.forEach(function (c) { c.checked = false; });
        self.render();
      });
    }

    /* Musteri adet kontrolunu dogrudan degistirirse hedefi guncelle.
       theme.js:966 bu olayi document uzerinde yayiyor. */
    document.addEventListener('variant:change', function () {
      window.requestAnimationFrame(function () {
        self.syncTargetFromVariant();
        self.render();
      });
    });
  };

  Picker.prototype.filter = function (term) {
    var q = String(term || '').trim().toLowerCase();
    var shown = 0;

    this.items.forEach(function (li) {
      var hit = !q || li.getAttribute('data-np-search').indexOf(q) !== -1;
      if (hit) {
        li.removeAttribute('hidden');
        shown++;
      } else {
        li.setAttribute('hidden', '');
      }
    });

    if (this.empty) {
      if (shown === 0) this.empty.removeAttribute('hidden');
      else this.empty.setAttribute('hidden', '');
    }
  };

  Picker.prototype.setHint = function (text) {
    if (this.hint) this.hint.textContent = text || '';
  };

  /* Secimi ≤450 karakterlik parcalara boler, ismin ortasindan asla kesmez. */
  Picker.prototype.chunk = function (parts) {
    var chunks = [];
    var current = '';

    parts.forEach(function (part) {
      var next = current ? current + ', ' + part : part;
      if (next.length > CHUNK_MAX && current) {
        chunks.push(current);
        current = part;
      } else {
        current = next;
      }
    });
    if (current) chunks.push(current);
    return chunks;
  };

  Picker.prototype.writePayload = function (valid, chosen) {
    var chunks = [];
    var codes = '';

    if (valid) {
      /* Tiklama sirasi degil, kanonik sira: ayni secim her zaman ayni dizeyi
         uretsin ki siparisler karsilastirilabilir olsun. */
      var sorted = chosen.slice().sort(function (a, b) {
        return +a.getAttribute('data-np-index') - +b.getAttribute('data-np-index');
      });
      chunks = this.chunk(
        sorted.map(function (c) {
          return c.getAttribute('data-np-index') + ' ' + c.getAttribute('data-np-label');
        })
      );
      codes = sorted
        .map(function (c) { return c.getAttribute('data-np-code'); })
        .join(',');
    }

    this.publics.forEach(function (input, i) {
      if (valid && chunks[i]) {
        input.value = chunks[i];
        input.disabled = false;
      } else {
        input.value = '';
        input.disabled = true;
      }
    });

    if (this.codesInput) {
      this.codesInput.value = valid ? codes : '';
      this.codesInput.disabled = !valid;
    }
    if (this.countInput) {
      this.countInput.value = valid ? String(chosen.length) : '';
      this.countInput.disabled = !valid;
    }
  };

  Picker.prototype.updateButton = function (valid, need) {
    if (!this.form) return;
    var btn = this.form.querySelector('[data-add-to-cart]');
    if (!btn) return;
    var label = btn.querySelector('[data-add-to-cart-text]');
    // Keeps the cart icon when the label text changes.
    var setLabel = function (text) {
      var icon = label.querySelector('svg');
      label.textContent = text;
      if (icon) label.prepend(icon, ' ');
    };

    if (valid) {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('iwa-np-blocked');
      if (label && label.getAttribute('data-np-stashed')) {
        setLabel(label.getAttribute('data-np-stashed'));
        label.removeAttribute('data-np-stashed');
      }
    } else {
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('iwa-np-blocked');
      if (label) {
        if (!label.getAttribute('data-np-stashed')) {
          label.setAttribute('data-np-stashed', label.textContent.trim());
        }
        setLabel(
          need > 0
            ? fill(T(this.root, 'button-more', 'Choose [n] more'), need)
            : T(this.root, 'button-start', 'Choose your names')
        );
      }
    }
  };

  Picker.prototype.render = function () {
    var chosen = this.selected();
    var n = chosen.length;
    var target = this.target;
    var valid = target !== null && n === target && n > 0;
    var need = target !== null ? target - n : 0;

    if (this.counter) {
      this.counter.textContent =
        target !== null
          ? fill(T(this.root, 'counter', '[n] / [t] selected'), n, target)
          : fill(T(this.root, 'counter-open', '[n] selected'), n);
    }
    if (this.clear) {
      if (n > 0) this.clear.removeAttribute('hidden');
      else this.clear.setAttribute('hidden', '');
    }

    /* Hedefe ulasildiginda kalan kutular DISABLE EDILMEZ; 103 ogelik bir
       gridde "hicbir yere basamiyorum" destek talebi uretir. Bunun yerine
       soluklastirilir ve degis-tokus onerilir. */
    this.items.forEach(function (li) {
      var c = li.querySelector('[data-np-check]');
      var muted = !c.checked && need <= 0 && target !== null;
      li.classList.toggle('iwa-np__item--muted', muted);
    });

    if (n === 0) this.setHint('');
    else if (need > 0) this.setHint(fill(T(this.root, 'choose-more', 'Choose [n] more to match your set size.'), need));
    else if (need < 0) this.setHint(fill(T(this.root, 'remove-some', 'Remove [n] to match your set size.'), -need));
    else this.setHint('');

    this.writePayload(valid, chosen);
    this.updateButton(valid, need);
  };

  function init() {
    toArray(document.querySelectorAll('[data-np]')).forEach(function (root) {
      if (root.hasAttribute('data-np-ready')) return;
      root.setAttribute('data-np-ready', '');
      new Picker(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('page:loaded', init);
})();
